import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareListaFisier } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareListaFisier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareListaFisier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.liste() });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
